import axios from "axios";
// src/utils/api.js
const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:6990";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const legacyToken = localStorage.getItem('token');
  const workspaceId = localStorage.getItem('activeWorkspaceId');
  if (legacyToken && !config.headers.Authorization) {
    config.headers.Authorization = 'Bearer ' + legacyToken;
  }
  if (workspaceId && !config.headers['X-Workspace-Id']) {
    config.headers['X-Workspace-Id'] = workspaceId;
    config.headers['X-Client-Id'] = workspaceId;
  }
  return config;
});

export default api;

// Transitional: legacy token fallback for fetch-based calls
function authHeaders() {
  const legacyToken = localStorage.getItem('token');
  const workspaceId = localStorage.getItem('activeWorkspaceId');
  return {
    ...(legacyToken ? { Authorization: 'Bearer ' + legacyToken } : {}),
    ...(workspaceId ? { 'X-Workspace-Id': workspaceId, 'X-Client-Id': workspaceId } : {}),
  };
}

async function handleResponse(res) {
  const contentType = res.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    const text = await res.text();
    console.error(`API returned non-JSON (${res.status}):`, text.slice(0, 200));
    return { success: false, message: `Server error (${res.status})` };
  }
  return res.json();
}

export async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
  });
  return handleResponse(res);
}

export async function apiPost(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}

export async function apiPut(path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  return handleResponse(res);
}

export async function apiDelete(path) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
  });
  return handleResponse(res);
}
